import React, { useEffect, useState } from "react";
import logo from "../../assets/img/logoN.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../assets/css/style.css";
import { getToken, removeToken } from "../../ auth";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

export default function NavBar() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const isHomePage = location.pathname === "/";
  const isRegisterPage = location.pathname === "/register";
  const isLoginPage = location.pathname === "/login";
  const hideLanguageSelector = isHomePage || isRegisterPage || isLoginPage;

  useEffect(() => {
    setIsLoggedIn(!!getToken());
  }, []);

  const handleLogout = () => {
    removeToken();
    setIsLoggedIn(false);
    navigate("/");
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
  };

  return (
    <nav className="navbar navbar-expand-md navbar-light bg-white shadow-sm sticky-top">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          <img src={logo} alt={t("brand_alt")} className="brand-logo" style={{ height: 36 }} />
        </Link>

        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
          aria-controls="mainNav"
          aria-expanded="false"
          aria-label="Ouvrir la navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="mainNav">
          <ul className="navbar-nav align-items-center gap-md-2">
            <li className="nav-item">
              <Link className="nav-link nav-link1" to="/">{t("home")}</Link>
            </li>

            {!isLoggedIn ? (
              <>
                <li className="nav-item">
                  <Link className="nav-link nav-link1" to="/login">
                    {t("login")}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link nav-link1" to="/register">
                    {t("register")}
                  </Link>
                </li>
              </>
            ) : (
              <li className="nav-item">
                <button
                  onClick={handleLogout}
                  className="btn btn-outline-dark px-3 py-2 rounded-3"
                >
                  {t("logout")}
                </button>
              </li>
            )}
            {!hideLanguageSelector && (
              <li className="nav-item ms-2">
                <select
                  className="form-select form-select-sm"
                  style={{ width: 150 }}
                  value={i18n.language?.startsWith("mg") ? "mg" : "fr"}
                  onChange={(e) => changeLanguage(e.target.value)}
                  aria-label="Select language"
                >
                  <option value="fr">🇫🇷 {t("lang_fr")}</option>
                  <option value="mg">🇲🇬 {t("lang_mg")}</option>
                </select>
              </li>
            )}

          </ul>
        </div>
      </div>
    </nav>
  );
}
